var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "pm-summary-index" },
    [
      _c(
        "div",
        { staticClass: "filters" },
        [
          _c("v-autocomplete", {
            attrs: {
              outlined: "",
              dense: "",
              clearable: "",
              label: "Filter Customer",
              items: _setup.customerState.items,
              "item-value": "id",
              "item-text": "company",
              loading: _setup.customerState.isLoading,
              "prepend-icon": "mdi-magnify",
              "hide-details": ""
            },
            model: {
              value: _setup.filters.customerId,
              callback: function($$v) {
                _vm.$set(_setup.filters, "customerId", $$v)
              },
              expression: "filters.customerId"
            }
          }),
          _c("v-select", {
            attrs: {
              outlined: "",
              dense: "",
              clearable: "",
              label: "Filter Year",
              items: _setup.yearOptions,
              "hide-details": ""
            },
            model: {
              value: _setup.filters.year,
              callback: function($$v) {
                _vm.$set(_setup.filters, "year", $$v)
              },
              expression: "filters.year"
            }
          })
        ],
        1
      ),
      _c("v-data-table", {
        attrs: {
          loading: _setup.tableState.isLoading,
          items: _setup.tableState.items,
          headers: _setup.headers,
          "sort-by": ["pm_month"],
          "sort-desc": [true]
        },
        scopedSlots: _vm._u([
          {
            key: "item.customer",
            fn: function({ item }) {
              return [
                _vm._v(
                  " " +
                    _vm._s(
                      item.customer ? item.customer.name : item.customer_id
                    ) +
                    " "
                )
              ]
            }
          },
          {
            key: "item.pm_month",
            fn: function({ item }) {
              return [
                _vm._v(" " + _vm._s(_setup.formatPmMonth(item.pm_month)) + " ")
              ]
            }
          },
          {
            key: "item.action",
            fn: function({ item }) {
              return [
                _c(
                  "div",
                  { staticStyle: { display: "flex", gap: "5px" } },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: {
                          icon: "",
                          outlined: "",
                          color: "red",
                          loading: _setup.printingSet.has(item.id)
                        },
                        on: {
                          click: function($event) {
                            return _setup.onPdfHandler(item.id)
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("mdi-file-pdf-box")])],
                      1
                    ),
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "", outlined: "", color: "warning" },
                        on: {
                          click: function($event) {
                            return _setup.router.push({
                              name: "preventive-maintenance.summary.edit",
                              params: { id: item.id }
                            })
                          }
                        }
                      },
                      [_c("v-icon", [_vm._v("mdi-pencil")])],
                      1
                    ),
                    _setup.authAccessLevel >= 7
                      ? _c(
                          "v-btn",
                          {
                            attrs: {
                              icon: "",
                              outlined: "",
                              color: "red",
                              loading: _setup.deletingSet.has(item.id)
                            },
                            on: {
                              click: function($event) {
                                return _setup.onDeleteHandler(item)
                              }
                            }
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }